import { Observable } from 'rxjs';

export abstract class UserImportService {
    abstract importUsers(file: File, org: string): Observable<any>;
}
